export default __webpack_public_path__ + "static/media/reactemployeetracker.0c50ac87.png";